import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App.js";
import "./index.css";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("Root element #root not found in index.html");
}

// The shell mounts at `/` with NO basename — it owns the whole platform path space and routes each
// module by path prefix (`/` close, `/admin/*` admin). One Router, one document, one auth session.
createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
